import axios from 'axios'

export function fetchMapTools ({ state, rootState, commit }, root) {
  const config = root.$config
  const url = config.oauth.token.replace('o/token/', 'geoportal/map-tools/')
  const accessToken = rootState.auth.accessToken
  return axios.get(url, { params: { access_token: accessToken } })
    .then(response => {
      const backendTools = response.data.tools.map(tool => {
        const configTool = config.tools[tool.name]
        if (configTool) {
          return { ...configTool, ...tool }
        }
        return tool
      })

      const toolsList = config.layout.home.tools || []
      const configTools = toolsList.filter(tool => {
        const exists = response.data.tools.some(t => t.name === tool)
        return tool in config.tools && !exists && config.tools[tool]
      }).filter(tool => {
        const toolObject = config.tools[tool]
        return !toolObject.supported || toolObject.supported.call(root, toolObject)
      }).map(tool => {
        const toolObject = config.tools[tool]
        toolObject.name = tool
        return toolObject
      })
      const tools = [...backendTools, ...configTools]

      commit('setMapTools', tools)
    })
}
